import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import * as styles from './ContentPostDetailNav.scss';

var ContentPostDetailNav = /*#__PURE__*/function (_Component) {
  _inherits(ContentPostDetailNav, _Component);

  var _super = _createSuper(ContentPostDetailNav);

  function ContentPostDetailNav() {
    var _this;

    _classCallCheck(this, ContentPostDetailNav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleNav", function (post) {
      var bucketPathChunk = _this.props.bucketSlug ? "/bucket/".concat(_this.props.bucketSlug) : '';
      browserHistory.push("/org/".concat(_this.props.organization.id, "/content").concat(bucketPathChunk, "/category/").concat(_this.props.categorySlug, "/post/").concat(post.id));
    });

    return _this;
  }

  _createClass(ContentPostDetailNav, [{
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          currentPostId = _this$props.currentPostId,
          posts = _this$props.posts,
          singlePosts = _this$props.singlePosts;
      var currentPostIndex = posts && posts.length ? posts.findIndex(function (p) {
        return parseInt(p.id, 10) === parseInt(currentPostId, 10);
      }) : null;
      var currentSinglePostIndex = singlePosts && singlePosts.length ? singlePosts.findIndex(function (p) {
        return parseInt(p.id, 10) === parseInt(currentPostId, 10);
      }) : null;
      var prevIndex = currentPostIndex - 1;
      var nextIndex = currentPostIndex + 1; // if currentPostIndex === -1, then we are looking at a single post not on the page behind the modal, so do not show nav

      return posts && posts.length && currentPostIndex !== -1 ? /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, prevIndex > -1 ? /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        onClick: function onClick() {
          _this2.handleNav(posts[prevIndex]);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-back ".concat(styles.arrow),
        style: {
          marginRight: 6
        }
      }), "Previous") : /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          visibility: 'hidden'
        }
      }, "p"), nextIndex < posts.length ? /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        onClick: function onClick() {
          _this2.handleNav(posts[nextIndex]);
        }
      }, "Next", /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-forward ".concat(styles.arrow),
        style: {
          marginLeft: 6
        }
      })) : /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          visibility: 'hidden'
        }
      }, "n")) : null;
    }
  }]);

  return ContentPostDetailNav;
}(Component);

export default ContentPostDetailNav;